import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import HomePage from './pages/HomePage';
import ParentSignup from './pages/ParentSignup';
import ParentLogin from './pages/ParentLogin';
import ChildLogin from './pages/ChildLogin';
import ParentDashboard from './pages/ParentDashboard';
import ParentSettings from './pages/ParentSettings';
import ParentSettlements from './pages/ParentSettlements';
import WalletManagement from './pages/WalletManagement';
import ChildDashboard from './pages/ChildDashboard';
import ChildPoints from './pages/ChildPoints';
import ChildRecords from './pages/ChildRecords';
import ChildBadges from './pages/ChildBadges';
import ChildSettings from './pages/ChildSettings';
import MissionManagement from './pages/MissionManagement';
import ApprovalManagement from './pages/ApprovalManagement';
import ChildrenManagement from './pages/ChildrenManagement';
import Reports from './pages/parent/Reports';
import RewardRequests from './pages/RewardRequests';

function App() {
  return (
    <Router future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
      <div className="container">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/parent/signup" element={<ParentSignup />} />
          <Route path="/parent/login" element={<ParentLogin />} />
          <Route path="/parent/dashboard" element={<ParentDashboard />} />
          <Route path="/parent/settings" element={<ParentSettings />} />
          <Route path="/parent/settlements" element={<ParentSettlements />} />
          <Route path="/parent/wallets" element={<WalletManagement />} />
          <Route path="/parent/missions" element={<MissionManagement />} />
          <Route path="/parent/missions/new" element={<MissionManagement />} />
          <Route path="/parent/approvals" element={<ApprovalManagement />} />
          <Route path="/parent/children" element={<ChildrenManagement />} />
          <Route path="/parent/reports" element={<Reports />} />
          <Route path="/parent/rewards" element={<RewardRequests />} />
          <Route path="/child/login" element={<ChildLogin />} />
          <Route path="/child/dashboard" element={<ChildDashboard />} />
          <Route path="/child/points" element={<ChildPoints />} />
          <Route path="/child/records" element={<ChildRecords />} />
          <Route path="/child/badges" element={<ChildBadges />} />
          <Route path="/child/settings" element={<ChildSettings />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;